document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('oplTechSearchInput');
  if (!searchInput) return;

  const products = document.querySelectorAll('.product-wrapper');

  // Normalise texte (minuscules + sans accents)
  function normalizeText(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  searchInput.addEventListener('input', function () {
    const query = normalizeText(this.value.trim());

    products.forEach(product => {
      const titleEl = product.querySelector('.title.h3');
      if (!titleEl) return;

      const titleText = normalizeText(titleEl.textContent);

      product.style.display = titleText.includes(query) ? '' : 'none';
    });
  });
});